<template>
  <div
    class="row justify-content-between"
    :class="{
      'flex-md-row-reverse': data.image_position === 'right' || !data.image_obj,
    }"
  >
    <div class="col-12 col-md-6 col-lg-5 text-center">
      <img
        class="image img-fluid"
        v-if="data.image_obj"
        :src="data.image_obj.storage_url"
      />
      <div class="thumbnail" v-else></div>
    </div>
    <div
      class="col-12 col-md-6 col-lg-5 d-flex flex-column justify-content-center mt-4 mt-md-0"
    >
      <div>
        <div class="mb-4">
          <h1 v-if="data.title">
            {{ data.title }}
          </h1>
          <h4 class="c-coral" v-if="data.subtitle">
            {{ data.subtitle }}
          </h4>
        </div>
        <div v-if="data.description" v-html="data.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudioSimpleContentPreview',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.image {
  max-height: 400px;
  border-radius: $border-radius;
}

.thumbnail {
  height: 400px;
  border-radius: $border-radius;
  background-color: $light-gray;
}
</style>
